import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

export const UPDATE_SETTING = 'UPDATE_SETTING';
export const GET_LEAD_STATUS = 'GET_LEAD_STATUS';
export const ADD_LEAD_STATUS = 'ADD_LEAD_STATUS';
export const UPDATE_LEAD_STATUS = 'UPDATE_LEAD_STATUS';
export const DELETE_LEAD_STATUS = 'DELETE_LEAD_STATUS';
export const GET_SETTING = 'GET_SETTING';
export const CREATE_WHATSAPP_MESSAGE = 'CREATE_WHATSAPP_MESSAGE';
export const GET_ALL_WHATSAPP_MESSAGE = 'GET_ALL_WHATSAPP_MESSAGE';
export const DELETE_WHATSAPP_MESSAGE = 'DELETE_WHATSAPP_MESSAGE';
export const UPDATE_WHATSAPP_MESSAGE = 'UPDATE_WHATSAPP_MESSAGE';
export const GET_WHATSAPP_BYID = 'GET_WHATSAPP_BYID';
export const GET_ALL_MESSAGE = 'GET_ALL_MESSAGE';

export const CREATE_VOICE_AI_DETAILS = 'CREATE_VOICE_AI_DETAILS';
export const UPDATE_VOICE_AI_DETAILS = 'UPDATE_VOICE_AI_DETAILS';
export const GET_VOICE_AI_DETAILS = 'GET_VOICE_AI_DETAILS';

export const GET_VOICE_AI_STATUS = 'GET_VOICE_AI_STATUS';
export const CREATE_VOICE_AI_STATUS = 'CREATE_VOICE_AI_STATUS';
export const UPDATE_VOICE_AI_STATUS = 'UPDATE_VOICE_AI_STATUS';
export const DELETE_VOICE_AI_STATUS = 'DELETE_VOICE_AI_STATUS';
export const ADD_CTC_CALLING = 'ADD_CTC_CALLING'

const updateSettingAction = (payload) => ({
  type: UPDATE_SETTING,
  payload: payload,
});
const getLeadStatusAction = (payload) => ({
  type: GET_LEAD_STATUS,
  payload: payload,
});
const addLeadStatusAction = (payload) => ({ type: ADD_LEAD_STATUS, payload });
const updateLeadStatusAction = (payload) => ({
  type: UPDATE_LEAD_STATUS,
  payload,
});
const deleteLeadStatusAction = (id) => ({
  type: DELETE_LEAD_STATUS,
  payload: id,
});
const getSettingAction = (payload) => ({ type: GET_SETTING, payload });
const createWhatsAppMessageAction = (payload) => ({
  type: CREATE_WHATSAPP_MESSAGE,
  payload,
});
const getAllWhatsAppMessageAction = (payload) => ({
  type: GET_ALL_WHATSAPP_MESSAGE,
  payload,
});
const deleteWhatsAppMessageAction = (payload) => ({
  type: DELETE_WHATSAPP_MESSAGE,
  payload,
});
const updateWhatsAppMessageAction = (payload) => ({
  type: UPDATE_WHATSAPP_MESSAGE,
  payload,
});
const getWhatsAppByIdAction = (payload) => ({
  type: GET_WHATSAPP_BYID,
  payload,
});
const getAllMessageAction = (payload) => ({ type: GET_ALL_MESSAGE, payload });

const createVoiceAIAction = (payload) => ({
  type: CREATE_VOICE_AI_DETAILS,
  payload,
});
const updateVoiceAIAction = (payload) => ({
  type: UPDATE_VOICE_AI_DETAILS,
  payload,
});
const getVoiceAIAction = (payload) => ({ type: GET_VOICE_AI_DETAILS, payload });

const getVoiceAIStatusAction = (payload) => ({
  type: GET_VOICE_AI_STATUS,
  payload,
});

const createVoiceAIStatusAction = (payload) => ({
  type: CREATE_VOICE_AI_STATUS,
  payload,
});

const updateVoiceAIStatusAction = (payload) => ({
  type: UPDATE_VOICE_AI_STATUS,
  payload,
});

const deleteVoiceAIStatusAction = (payload) => ({
  type: DELETE_VOICE_AI_STATUS,
  payload,
});

const addCtcCallingAction = (payload) => ({ type: ADD_CTC_CALLING, payload });


// Get All Lead Statuses
export const getSetting = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASEURL}/Setting/getSetting`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log('🚀 ~ getSetting ~ res:', res);
      // Check if we have valid data
      if (!res.data) {
        console.error('No data received from getSetting API');
        toast.error('Failed to load settings: No data received');
        return;
      }

      // Process the logo URL to ensure it's accessible
      if (res.data.logo) {
        // If the logo is already a complete URL (like Cloudinary), use it as is
        if (res.data.logo.startsWith('http')) {
          res.data.logo = res.data.logo;
        } else {
          // If it's a relative path, prepend the BASEURL
          res.data.logo = `${BASEURL}/${res.data.logo}`;
        }
      }

      // Structure the data for Redux state
      const settingsData = {
        getSetting: {
          _id: res.data._id,
          logo: res.data.logo || '',
          leadStatuses: res.data.leadStatuses || [],
          facebookPageAccessToken: res.data.facebookPageAccessToken || '',
          voiceAIDetails: res.data.voiceAIDetails || {},
          voiceAIStatus: res.data.voiceAIStatus || []
        },
      };

      console.log('Dispatching settings data:', settingsData);
      dispatch(getSettingAction(settingsData));
      if (res.data.voiceAIDetails) {
        dispatch(getVoiceAIAction(res.data.voiceAIDetails));
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error(error?.response?.data?.message || 'Failed to load settings!');
    }
  };
};

export const updateSetting = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();

      // Handle both regular payload and file upload
      if (payload instanceof FormData) {
        // If it's already a FormData object (for file upload)
        formData.append('logo', payload.get('logo'));
      } else {
        // If it's a regular object
        Object.keys(payload).forEach((key) => {
          formData.append(key, payload[key]);
        });
      }

      const res = await axios.put(
        `${BASEURL}/Setting/updateSetting`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      // Process the response logo URL
      if (res.data && res.data.logo) {
        // If the logo is a Cloudinary URL, use it directly
        if (res.data.logo.startsWith('http')) {
          res.data.logo = res.data.logo;
        } else {
          // If it's a relative path, prepend the BASEURL
          res.data.logo = `${BASEURL}/uploads/${res.data.logo}`;
        }
      }

      dispatch(updateSettingAction(res.data));
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to update settings',
      );
      console.error('Error updating settings:', error);
      throw error;
    }
  };
};

// Get All Lead Statuses
export const getLeadStatusesWithPagination = (page, limit) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(
        `${BASEURL}/Setting/all-with-pagination?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(getLeadStatusAction(res.data));
      return res;
    } catch (error) {
      console.error('Error fetching lead statuses:', error);
      toast.error('Failed to load lead statuses!');
    }
  };
};

// Add New Lead Status
export const addLeadStatus = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/Setting/add-lead-status`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(addLeadStatusAction(res.data));
      toast.success('Lead Status added successfully!');
    } catch (error) {
      console.error('Error adding lead status:', error);
      toast.error('Failed to add lead status!');
    }
  };
};

// Update Lead Status
export const updateLeadStatus = (id, payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(`${BASEURL}/Setting/update/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(updateLeadStatusAction(res.data));
      toast.success('Lead Status updated successfully!');
    } catch (error) {
      console.error('Error updating lead status:', error);
      toast.error('Failed to update lead status!');
    }
  };
};

// Delete Lead Status
export const deleteLeadStatus = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASEURL}/Setting/delete/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(deleteLeadStatusAction(id));
      toast.success('Lead Status deleted successfully!');
    } catch (error) {
      console.error('Error deleting lead status:', error);
      toast.error('Failed to delete lead status!');
    }
  };
};

// Add New WhatsApp Message
export const addWhatsAppMessage = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/Setting/whatsapp-message`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(createWhatsAppMessageAction(res.data));
    } catch (error) {
      console.error('Error adding WhatsApp Message:', error);
      toast.error('Failed to add WhatsApp Message!');
    }
  };
};

// Get ALL WhatsApp Message
export const getWhatsAppMessage = (page, limit) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(
        `${BASEURL}/Setting/whatsapp-message?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(getAllWhatsAppMessageAction(res.data));
      return res;
    } catch (error) {
      console.error('Error adding WhatsApp Message:', error);
      toast.error('Failed to add WhatsApp Message!');
    }
  };
};

// Get ALL WhatsApp Message
export const getMessage = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASEURL}/Setting/whatsapp-message-all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(getAllMessageAction(res.data));
      return res;
    } catch (error) {
      console.error('Error adding WhatsApp Message:', error);
      toast.error('Failed to add WhatsApp Message!');
    }
  };
};

// Get WhatsApp Message BY ID
export const getWhatsAppMessageById = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/Setting/whatsapp-message/${payload.id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(getWhatsAppByIdAction(res.data));
      toast.success('WhatsApp Message get successfully!');
    } catch (error) {
      console.error('Error adding WhatsApp Message:', error);
      toast.error('Failed to add WhatsApp Message!');
    }
  };
};

// Update WhatsApp Message
export const updateWhatsAppMessage = (id, payload) => {
  console.log('🚀 ~ updateWhatsAppMessage ~ action >> id:', id);
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(
        `${BASEURL}/Setting/whatsapp-message/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(updateWhatsAppMessageAction(res.data));
      toast.success('WhatsApp Message updated successfully!');
    } catch (error) {
      console.error('Error updating WhatsApp Message:', error);
      toast.error('Failed to update WhatsApp Message!');
    }
  };
};

// Delete WhatsApp Message
export const deleteWhatsAppMessage = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASEURL}/Setting/whatsapp-message/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(deleteWhatsAppMessageAction(id));
      toast.success('WhatsApp Message deleted successfully!');
    } catch (error) {
      console.error('Error deleting WhatsApp Message:', error);
      toast.error('Failed to delete WhatsApp Message!');
    }
  };
};

export const createVoiceAIDetails = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/Setting/createVoiceAIDetails`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      dispatch(createVoiceAIAction(res.data));
      return res;
    } catch (error) {
      console.error('Error creating Voice AI details:', error);
    }
  };
};

export const updateVoiceAIDetails = (id, payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(
        `${BASEURL}/Setting/updateVoiceAIDetails/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      dispatch(updateVoiceAIAction(res.data));
      return res;
    } catch (error) {
      console.error('Error updating Voice AI details:', error);
    }
  };
};

export const createVoiceAIStatus = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${BASEURL}/Setting/createVoiceAIStatus`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(createVoiceAIStatusAction(res.data));
      return res;
    } catch (err) {
      console.error('Error creating Voice AI status:',err);
    }
  };
};

export const getVoiceAIStatus = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${BASEURL}/Setting/getVoiceAIStatus`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      dispatch(getVoiceAIStatusAction(res.data));
      return res;
    } catch (err) {
      console.error("Error fetching Voice AI Status:", err);
    }
  };
};

export const updateVoiceAIStatus = (id, payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.put(
        `${BASEURL}/Setting/updateVoiceAIStatus/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch(updateVoiceAIStatusAction(res.data));
      return res;
    } catch (err) {
      console.error(err);
    }
  };
};

export const deleteVoiceAIStatus = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${BASEURL}/Setting/deleteVoiceAIStatus/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      dispatch(deleteVoiceAIStatusAction(id));
    } catch (err) {
      console.error(err);
    }
  };
};

// ctc calling
export const addCtcCalling = (id, payload) => {
  return async (dispatch) => {
    try {
        const token = localStorage.getItem('token')
        const res = await axios.post(`${BASEURL}/ctcCalling/callLead/${id}?entityType=${payload.entityType}`,
        {},
        {
          "headers": {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
          }
        });
      dispatch(addCtcCallingAction(res.data));
      return res;
    } catch (error) {
      console.error("Error adding CTC calling:", error);
      throw error;
    }
  };
};
